export class UrlUtils {


public static removeDuplicateUrlSegments(url: string): string {
  // Normalize leading/trailing slashes
  const normalized = url.replace(/\/+$/, '').replace(/^\/+/, '');

  const segments = normalized.split('/');
  const uniqueSegments: string[] = [];

  for (let i = 0; i < segments.length; i++) {
    // Add segment only if it's not identical to the previous one
    if (segments[i] !== segments[i - 1]) {
      uniqueSegments.push(segments[i]);
    }
  }

  return '/' + uniqueSegments.join('/');
}

}